import { render, staticRenderFns } from "./ConfirmPengirimanModal.vue?vue&type=template&id=65c2ffaf&scoped=true"
import script from "./ConfirmPengirimanModal.vue?vue&type=script&lang=js"
export * from "./ConfirmPengirimanModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmPengirimanModal.vue?vue&type=style&index=0&id=65c2ffaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c2ffaf",
  null
  
)

export default component.exports